/**
 * Fill missing dates in a date range with zero values.
 * Ensures charts show the full date axis even when there's no data.
 */
export function fillDateRange(
  data: { date: string; value: number; value2?: number }[],
  dateFrom: string,
  dateTo: string
): { date: string; value: number; value2?: number }[] {
  const map = new Map<string, { value: number; value2?: number }>();
  data.forEach((d) => map.set(d.date, { value: d.value, value2: d.value2 }));

  const result: { date: string; value: number; value2?: number }[] = [];
  const start = new Date(dateFrom);
  const end = new Date(dateTo);

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const key = d.toISOString().split("T")[0];
    const existing = map.get(key);
    result.push({
      date: key,
      value: existing?.value ?? 0,
      value2: existing?.value2 ?? (data.some((x) => x.value2 !== undefined) ? 0 : undefined),
    });
  }

  return result;
}
